const displayDuration = (totalHours) => {
  if (!totalHours) return ""

  const hours = Math.floor(totalHours)
  const minutes = Math.round((totalHours - hours) * 60)
  return `${hours}h ${minutes}m`
}

export default displayDuration
